import { render, staticRenderFns } from "./zhuzuo.vue?vue&type=template&id=4bdc3f6a&scoped=true&"
import script from "./zhuzuo.vue?vue&type=script&lang=js&"
export * from "./zhuzuo.vue?vue&type=script&lang=js&"
import style0 from "./zhuzuo.vue?vue&type=style&index=0&id=4bdc3f6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bdc3f6a",
  null
  
)

export default component.exports